// BHPNPP-3069: Export audit log types.

export type ExportAuditModule = 'AUTHORIZATIONS' | 'PARENT_CASES' | 'SUBMITTED_REQUESTS' | 'AT_RISK' | 'AUTHORIZATION_BILLING';

export type ExportStatus = 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED';

/** One audit row (node of the exportAuditLog connection). */
export type ExportAuditRow = {
    guid: string;
    requestedAt: string;
    requestedByFirstName: string;
    requestedByLastName: string;
    requestedByEmail: string;
    module: ExportAuditModule;
    /** The grid's filter snapshot, verbatim; rendered by describeFilters. */
    filtersJson: string | null;
    /** Null until COMPLETED - tallied during generation. */
    recordCount: number | null;
    status: ExportStatus;
    /** Set on FAILED only. */
    errorMessage: string | null;
    /**
     * Derived from filtersJson on render, not queried. Applied Filters and Search Criteria are two
     * audit fields, so the table needs a column key for each.
     */
    filterLines?: string[];
    searchText?: string | null;
};

/**
 * ExportModule.PARENT_CASES keeps the label "Parent Cases" on the backend, where it drives generated
 * file names; the page it audits is called Client Care.
 */
export const MODULE_LABELS: Record<ExportAuditModule, string> = {
    AUTHORIZATIONS: 'Authorizations',
    PARENT_CASES: 'Client Care',
    SUBMITTED_REQUESTS: 'Submitted Requests',
    AT_RISK: 'Client Offer - At Risk',
    AUTHORIZATION_BILLING : 'Authorization Billing'
};
